var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B9CC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m13.1 7.297-1.227-2.455c-.353-.706-.53-1.06-.793-1.317a2.2 2.2 0 0 0-.822-.508c-.349-.12-.744-.12-1.533-.12H4.52c-1.232 0-1.848 0-2.319.24a2.2 2.2 0 0 0-.961.96C1 4.569 1 5.185 1 6.418v.88m0 0h16.72c1.848 0 2.772 0 3.478.36a3.3 3.3 0 0 1 1.442 1.441c.36.706.36 1.63.36 3.479v4.84c0 1.848 0 2.772-.36 3.478a3.3 3.3 0 0 1-1.442 1.442c-.706.36-1.63.36-3.478.36H6.28c-1.848 0-2.772 0-3.478-.36a3.3 3.3 0 0 1-1.442-1.442C1 20.189 1 19.265 1 17.417z"
  })));
};
export default SvgBookmark;